export const SCHOOl = [
  { "label": "Escuela Normal Superior Nº 8", "value": "Escuela Normal Superior Nº 8" },
  { "label": "Escuela Provincial Nº 615", "value": "Escuela Provincial Nº 615" },
  { "label": "Escuela Provincial Nº 462", "value": "Escuela Provincial Nº 462" },
  { "label": "Escuela Provincial Nº 837", "value": "Escuela Provincial Nº 837" },
  { "label": "Escuela Provincial Nº 789", "value": "Escuela Provincial Nº 789" },
  { "label": "Escuela Provincial Nº 875", "value": "Escuela Provincial Nº 875" },
  { "label": "Escuela Provincial Nº 703", "value": "Escuela Provincial Nº 703" },
  { "label": "Escuela Provincial Nº 697", "value": "Escuela Provincial Nº 697" },
  { "label": "Escuela Provincial Nº 204", "value": "Escuela Provincial Nº 204" },
  { "label": "Escuela Provincial Nº 2", "value": "Escuela Provincial Nº 2" },
  { "label": "Escuela Provincial Nº 99", "value": "Escuela Provincial Nº 99" },
  { "label": "Escuela Provincial Nº 875", "value": "Escuela Provincial Nº 875" },
  { "label": "Escuela Provincial Nº 185", "value": "Escuela Provincial Nº 185" },
  { "label": "Escuela Provincial Nº 367", "value": "Escuela Provincial Nº 367" },
  { "label": "Escuela Provincial Nº 513", "value": "Escuela Provincial Nº 513" },
  { "label": "Escuela Provincial Nº 678", "value": "Escuela Provincial Nº 678" },
  { "label": "Escuela Provincial Nº 989", "value": "Escuela Provincial Nº 989" },
  { "label": "Escuela Provincial Nº 54", "value": "Escuela Provincial Nº 54" },
  { "label": "Escuela Provincial Nº 707", "value": "Escuela Provincial Nº 707" },
  { "label": "Escuela Provincial Nº 344", "value": "Escuela Provincial Nº 344" },
  { "label": "Escuela Provincial Nº 621", "value": "Escuela Provincial Nº 621" },
  { "label": "Escuela Provincial Nº 760", "value": "Escuela Provincial Nº 760" },
  { "label": "Escuela Provincial Nº 471", "value": "Escuela Provincial Nº 471" },
  { "label": "Escuela Provincial Nº 809", "value": "Escuela Provincial Nº 809" },
  { "label": "Escuela Provincial Nº 952", "value": "Escuela Provincial Nº 952" },
  { "label": "Escuela Provincial Nº 235", "value": "Escuela Provincial Nº 235" },
  { "label": "Escuela Provincial Nº 146", "value": "Escuela Provincial Nº 146" },
  { "label": "Escuela Provincial Nº 403", "value": "Escuela Provincial Nº 403" },
  { "label": "Escuela Provincial Nº 382", "value": "Escuela Provincial Nº 382" },
  { "label": "Escuela Provincial Nº 89", "value": "Escuela Provincial Nº 89" },
  { "label": "Escuela Provincial Nº 567", "value": "Escuela Provincial Nº 567" },
  { "label": "Escuela Provincial Nº 845", "value": "Escuela Provincial Nº 845" },
  { "label": "Escuela Provincial Nº 349", "value": "Escuela Provincial Nº 349" },
  { "label": "Escuela Provincial Nº 156", "value": "Escuela Provincial Nº 156" },
  { "label": "Escuela Provincial Nº 970", "value": "Escuela Provincial Nº 970" },
  { "label": "Escuela Provincial Nº 209", "value": "Escuela Provincial Nº 209" },
  { "label": "Escuela Provincial Nº 542", "value": "Escuela Provincial Nº 542" },
  { "label": "Escuela Provincial Nº 394", "value": "Escuela Provincial Nº 394" },
  { "label": "Escuela Provincial Nº 146", "value": "Escuela Provincial Nº 146" },
  { "label": "Escuela Provincial Nº 705", "value": "Escuela Provincial Nº 705" },
  { "label": "Escuela Provincial Nº 510", "value": "Escuela Provincial Nº 510" },
  { "label": "Escuela Provincial Nº 834", "value": "Escuela Provincial Nº 834" },
  { "label": "Escuela Provincial Nº 914", "value": "Escuela Provincial Nº 914" },
  { "label": "Escuela Provincial Nº 613", "value": "Escuela Provincial Nº 613" },
  { "label": "Escuela Provincial Nº 799", "value": "Escuela Provincial Nº 799" },
  { "label": "Escuela Provincial Nº 137", "value": "Escuela Provincial Nº 137" }
]
